"use client";

import { Spinner } from "react-bootstrap";

type AuthTransitionLoaderProps = {
    message: string;
    progressText?: string;
    testId?: string;
};

export default function AuthTransitionLoader({
    message,
    progressText,
    testId = "auth-transition-loader",
}: AuthTransitionLoaderProps) {
    return (
        <div
            data-testid={testId}
            style={{
                minHeight: "70vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "4rem 1.5rem",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.875rem",
                    textAlign: "center",
                }}
            >
                <Spinner
                    animation="border"
                    role="status"
                    style={{
                        width: "2rem",
                        height: "2rem",
                        color: "#2563eb",
                    }}
                />
                <p
                    style={{
                        margin: 0,
                        color: "#475569",
                        fontSize: "0.95rem",
                        fontWeight: 500,
                        lineHeight: 1.5,
                    }}
                >
                    {progressText || message}
                </p>
            </div>
        </div>
    );
}
